export const projects = [
    {
        title: 'Simple Chat',
        description: 'A real time chat application developed using django & websockets.',
        animation: 'https://lottie.host/2bcf38f4-d709-4b39-a1a8-ba1247d9d992/kmln7WqWZk.lottie',
        techStack: ["Python", "Django", "WebSockets", "Channels", "Redis"],
        images: [
            'images/projects/simple_chat/0.png',
            'images/projects/simple_chat/1.png',
            'images/projects/simple_chat/2.png',
            'images/projects/simple_chat/3.png',
            'images/projects/simple_chat/4.png',
        ],
        long_desc: ``,
        objectives: [
            'Learn: Understood how messaging technology works using WebSockets for real-time communication.',
            'Build: Create a functional chat application using Django, Channels, and Redis as the backend.',
            'Explore: Gain hands-on experience with real-time data handling and integration of WebSockets into web applications.'
        ],
        orientation: 'landscape'
    },
    {
        title: 'Routing Algorithm',
        description: 'An Novel Ship Routing Algorithm that finds the shortest path for ships',
        animation: 'https://lottie.host/83e97d78-9870-4c78-806e-25314323d526/otCHvoqQ36.lottie',
        techStack: ["Python", "Folium", "Pandas", "Numpy", "Django"],
        images: [
            'images/projects/routing_algorithm/0.png',
            'images/projects/routing_algorithm/1.png',
            'images/projects/routing_algorithm/2.png',
            'images/projects/routing_algorithm/3.png',
        ],
        long_desc: ``,
        objectives: [
            'To determine optimal routing solutions considering voyage economics',
            'To formulate an accurate route by integrating oceanic dynamics',
            'To reduce emissions for sustainable shipping by harnessing oceanic data-driven insights'
        ],
        orientation: 'landscape'
    },
    {
        title: 'QuickHire',
        description: 'A mobile application which connects job seekers and job providers.',
        animation: 'https://assets8.lottiefiles.com/packages/lf20_UtkD3sPBCg.json',
        techStack: ["Flutter", "OAuth", "Django", "Python", "RazorPay"],
        images: [
            'images/projects/quick_hire/0.jpg',
            'images/projects/quick_hire/1.jpg',
            'images/projects/quick_hire/2.jpg',
            'images/projects/quick_hire/3.jpg',
            'images/projects/quick_hire/4.jpg',
        ],
        long_desc: ``,
        objectives: [
            'Implemented Server using Django, Gunicorn, Nginx on a cloud-based Linux System',
            'Rest API to connect server and mobile application',
            'Integrated RazorPay Payment Gateway for payments'
        ],
        orientation: 'potrait'
    },
    {
        title: 'Sign2Speech',
        description: 'A Python project that converts sign language to text helping deaf people communicate.',
        animation: 'https://lottie.host/7cd1b8ca-3d15-42b6-99a4-304ad37e0160/hi6C5P8TSC.lottie',
        techStack: ["Python", "Pandas", "Numpy", "OpenCV", "Tensorflow"],
        images: [
            'images/projects/sign_2_speech/0.jpg',
            'images/projects/sign_2_speech/1.jpg',
            'images/projects/sign_2_speech/2.jpg',
            'images/projects/sign_2_speech/3.jpg',
        ],
        long_desc: ``,
        objectives: [
            'To develop a system that can recognize sign language gestures and convert them into text',
            'To empower individuals with hearing impairments, providing them a tool to express themselves more effectively in a world with communication barriers.'
        ],
        orientation: 'landscape'
    },
    {
        title: 'SheShopPlace',
        description: 'An Ecommerce website for ladies to shop for their favorite items.',
        animation: 'https://lottie.host/40ce92ad-d3b2-49ea-b753-cce1f2302691/b49xKlrK3J.lottie',
        techStack: ["Python", "Folium", "Pandas", "Numpy", "Django"],
        images: [
            'images/projects/sheshopplace/0.jpg',
            'images/projects/sheshopplace/1.jpg',
        ],
        long_desc: ``,
        objectives: [
            'To create an e-commerce platform that celebrates diversity, fosters entrepreneurship, and empowers women by providing a curated selection of fashion, beauty, lifestyle, and wellness products.',
            'To offer a seamless shopping experience, with a user-friendly interface, secure payment gateways, and efficient delivery services.'
        ],
        orientation: 'landscape'
    },
    {
        title: 'College Connect',
        description: 'An Android application that connects students and teachers in a college.',
        animation: 'https://lottie.host/63529143-311d-49a4-8b18-8974a080cc91/G8WdXcnQS4.lottie',
        techStack: ["Python", "Folium", "Pandas", "Numpy", "Django"],
        images: [
            'images/projects/college_connect/0.png',
            'images/projects/college_connect/1.png',
            'images/projects/college_connect/2.png',
            'images/projects/college_connect/3.png',
            'images/projects/college_connect/4.png',
        ],
        long_desc: ``,
        objectives: [
            'An application designed to facilitate seamless connections among students, enabling them to collaborate and engage with one another.',
            'Follows the MVVM architecture (Model-View-ViewModel) to ensure separation of concerns, making the app modular, maintainable, and scalable.'
        ],
        orientation: 'potrait'
    },
    {
        title: 'LOSTIE',
        description: 'An Android application that helps Students find thier lost devices in college campus.',
        animation: 'https://lottie.host/60c96127-6f6c-4b71-952c-03f0fefbe938/idhqfyBrCg.lottie',
        techStack: ["Python", "Folium", "Pandas", "Numpy", "Django"],
        images: [
            'images/projects/lostie/0.jpg',
            'images/projects/lostie/1.jpg',
            'images/projects/lostie/2.jpg',
        ],
        long_desc: ``,
        objectives: [
            'To help colleges maintain a database and proper reporting system for lost items on campus, allowing users to easily find their lost belongings through the app.',
            'To enable users to submit any lost and found items they receive on campus, ensuring items are returned to their rightful owners.'
        ],
        orientation: 'potrait'
    },
    {
        title: 'BudgetWise',
        description: 'An Android application that helps students manage their budget.',
        animation: 'https://lottie.host/8faf9118-4b5d-4f0b-85f1-090f0cc08a40/n4P7ZUxy8z.lottie',
        techStack: ["Python", "Folium", "Pandas", "Numpy", "Django"],
        images: [
            'images/projects/budgetwise/0.png',
            'images/projects/budgetwise/1.png',
            'images/projects/budgetwise/2.png',
            'images/projects/budgetwise/3.png',
            'images/projects/budgetwise/4.png',
            'images/projects/budgetwise/5.png',
            'images/projects/budgetwise/6.png',
            'images/projects/budgetwise/7.png',
        ],
        long_desc: ``,
        objectives: [
            'To help students manage their finances effectively, track their expenses, and set budgets for various categories.',
            'To provide a user-friendly interface that allows students to visualize their spending habits, set financial goals, and make informed decisions about their money.',
            'To provide users with a comprehensive tool for tracking and managing their income and expenses, ensuring better financial control and budgeting.'
        ],
        orientation: 'potrait'
    },
    {
        title: 'Covid Smasher',
        description: 'An Android applications that keeps track of Covid cases and news in the country.',
        animation: 'https://lottie.host/70fd3c66-cbfa-408c-a7e9-6cca7494baf6/YnP1ymUiCC.lottie',
        techStack: ["Python", "Folium", "Pandas", "Numpy", "Django"],
        images: [
        ],
        long_desc: ``,
        objectives: [
            'To provide users with real-time updates on the COVID-19 pandemic, including case counts, vaccination rates, and news updates.',
            'To help users stay informed about the latest developments in the pandemic, enabling them to make informed decisions about their health and safety.',
            'To provide users to check for nearby vaccination centers and book slots for vaccination.'
        ],
        orientation: 'potrait'
    },
    {
        title: 'FoodCanteen',
        description: 'A PHP backed website that helps students order food from the college canteen.',
        animation: 'https://lottie.host/a975d6e2-4d10-4a5f-b4b4-91332e1f453e/V5y9VrpI4e.lottie',
        techStack: ["Python", "Folium", "Pandas", "Numpy", "Django"],
        images: [
            'images/projects/food_canteen/0.png',
        ],
        long_desc: ``,
        objectives: [
            'To provide students with a convenient way to order food from the college canteen, enabling them to skip the line and save time.',
            'To help canteen staff manage orders more efficiently, reducing wait times and improving customer satisfaction.'
        ],
        orientation: 'potrait'
    },
]

export const skills = [
    { id: 0, name: "Android", photo: "https://upload.wikimedia.org/wikipedia/commons/6/64/Android_logo_2019_%28stacked%29.svg", rate: '90%', isLeft: true },
    { id: 1, name: "Kotlin", photo: "https://upload.wikimedia.org/wikipedia/commons/0/06/Kotlin_Icon.svg", rate: '80%', isLeft: true },
    { id: 2, name: "React Js", photo: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg", rate: '60%', isLeft: true },
    { id: 3, name: "JavaScript", photo: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png", rate: '60%', isLeft: true },
    { id: 4, name: "Flutter", photo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Google-flutter-logo.svg/330px-Google-flutter-logo.svg.png", rate: '90%', isLeft: true },
    { id: 5, name: "C++", photo: "https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg", rate: '85%', isLeft: false },
    { id: 6, name: "Java", photo: "https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg", rate: '85%', isLeft: false },
    { id: 7, name: "PHP", photo: "https://upload.wikimedia.org/wikipedia/commons/2/27/PHP-logo.svg", rate: '70%', isLeft: false },
    { id: 8, name: "TailwindCSS", photo: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg", rate: '60%', isLeft: true },
    { id: 9, name: "Firebase", photo: "https://firebase.google.com/static/images/brand-guidelines/logo-logomark.png", rate: '70%', isLeft: true },
    { id: 10, name: "MySQL", photo: "https://upload.wikimedia.org/wikipedia/commons/0/0a/MySQL_textlogo.svg", rate: '60%', isLeft: true },
    { id: 11, name: "Git", photo: "https://upload.wikimedia.org/wikipedia/commons/3/3f/Git_icon.svg", rate: '80%', isLeft: true },
    { id: 12, name: "Python", photo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/182px-Python-logo-notext.svg.png", rate: '80%', isLeft: true },
    { id: 13, name: "Django", photo: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/182px-Python-logo-notext.svg.png", rate: '80%', isLeft: true },
]

export const SERVICE_ID = 'service_2v2s3gi';
export const TEMPLATE_ID = 'template_49hl226';
export const PUBLIC_KEY = 'rhCP0wS0Nvge4HZg4';

export const experience1 = [
    {
        year: "Jul '24 - Present",
        title: "Software Developer & Trainer",
        company: "SELF-EMPLOYED",
        description: (
            <ul className="list-disc ml-5 text-sm ">
                <li className="mb-2">Conducted a Full Stack Development workshop for 100+ diploma students, covering HTML, CSS, JavaScript, JSP.</li>
                <li className="mb-2">Designed and launched over 10 custom websites and mobile applications for small businesses.</li>
                <li className="mb-2">Developed projects for Final-year Indian Students and International Students.</li>
                <li className="mb-2">Managed end-to-end project life-cycles, ensuring timely delivery within budget.</li>
            </ul>
        )
    },
    {
        year: "Mar '24 - Jun '24",
        title: "Android Developer Intern",
        company: "DIVE IN 2 DIGITAL",
        description: (
            <ul className="list-disc ml-5 text-sm ">
                <li className="mb-2">Contributed to more than 4 android applications.</li>
                <li className="mb-2">Increased client retention by 35% by optimizing API calls.</li>
                <li className="mb-2">Integrated payment gateways for secure and seamless transactions.</li>
            </ul>
        )
    },

];
export const experience2 = [
    {
        year: "Oct '22 - Dec '22",
        title: "Android Developer Intern",
        company: "MENDOFEEL CO.",
        description: (
            <ul className="list-disc ml-5 text-sm ">
                <li className="mb-2">Migrated 70% of code-base from Java to Kotlin code.</li>
                <li className="mb-2">Developed Reels-like news feature to increase user time by 50%.</li>
                <li className="mb-2">Implemented MVVM Architecture with Repository pattern for better performance.</li>
            </ul>
        )
    },
    {
        year: "Oct '21 - Dec '21",
        title: "Marketing Intern",
        company: "BYJUS",
        description: (
            <ul className="list-disc ml-5 text-sm ">
                <li className="mb-2">Learned about generating leads</li>
                <li className="mb-2">Generated more than 100+ leads during my internship.</li>
            </ul>
        )
    },
    {
        year: "Mar '21 - Aug '21",
        title: "Accountant",
        company: "SIREN ELECTRICALS CAL",
        description: (
            <ul className="list-disc ml-5 text-sm ">
                <li className="mb-2">Prepared and analyzed monthly and annual financial statements</li>
            </ul>
        )
    },
];

export const education = [
    {
        year: "2022 - 2025",
        title: "Bachelor's Degree in Computer Science & Engineering",
        description: "Sambhram Institute of Technology, Bangalore, India"
    },
    {
        year: "2019 - 2022",
        title: "Diploma in Information Technology",
        description: "Parul Polytechnic Institute, Vadodara, India"
    },
    {
        year: "2019",
        title: "Class 10th (WBSE)",
        description: "The Calcutta Anglo Gujarati School, Kolkata, India"
    }
];

// Utility to check if the screen is mobile
const isMobile = window.innerWidth <= 768; // Adjust the breakpoint as needed

// Common animation configurations based on direction
const leftAnimation = {
  variants: isMobile
    ? {} // Disable animations for mobile
    : {
        hidden: {
          x: '100%',
          opacity: 0,
        },
        show: {
          x: 0,
          opacity: 1,
          transition: {
            type: 'tween',
            duration: 1.2,
            delay: 0.2, // Adjust as needed
            ease: [0.25, 0.25, 0.25, 0.75],
          },
        },
      },
  initial: isMobile ? false : 'hidden', // Disable initial state on mobile
  whileInView: isMobile ? false : 'show', // Disable whileInView on mobile
  viewport: isMobile ? {} : { once: false, amount: 0.1 }, // Disable viewport settings on mobile
};

const rightAnimation = {
  variants: isMobile
    ? {}
    : {
        hidden: {
          x: '-100%',
          opacity: 0,
        },
        show: {
          x: 0,
          opacity: 1,
          transition: {
            type: 'tween',
            duration: 1.2,
            delay: 0.2, // Adjust as needed
            ease: [0.25, 0.25, 0.25, 0.75],
          },
        },
      },
  initial: isMobile ? false : 'hidden',
  whileInView: isMobile ? false : 'show',
  viewport: isMobile ? {} : { once: false, amount: 0.1 },
};

const upAnimation = {
  variants: isMobile
    ? {}
    : {
        hidden: {
          opacity: 0,
          y: 20,
        },
        show: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.3,
            delay: 0.2, // Adjust as needed
            ease: 'easeOut',
          },
        },
      },
  initial: isMobile ? false : 'hidden',
  whileInView: isMobile ? false : 'show',
  viewport: isMobile ? {} : { once: true, amount: 0.1 },
};

const downAnimation = {
  variants: isMobile
    ? {}
    : {
        hidden: {
          opacity: 0,
          y: -20,
        },
        show: {
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.3,
            delay: 0.2, // Adjust as needed
            ease: 'easeOut',
          },
        },
      },
  initial: isMobile ? false : 'hidden',
  whileInView: isMobile ? false : 'show',
  viewport: isMobile ? {} : { once: true, amount: 0.1 },
};

export { leftAnimation, rightAnimation, upAnimation, downAnimation };